module.exports = __webpack_public_path__ + "static/media/incidentInactive.56939001.png";